var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExhibition(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.66 9.16003H22.33C20.1208 9.16003 18.33 10.9509 18.33 13.16V38.18C18.33 40.3892 20.1208 42.18 22.33 42.18H65.66C67.8691 42.18 69.66 40.3892 69.66 38.18V13.16C69.66 10.9509 67.8691 9.16003 65.66 9.16003Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.59 55.03C17.1143 55.03 18.35 53.7943 18.35 52.27C18.35 50.7457 17.1143 49.51 15.59 49.51C14.0657 49.51 12.83 50.7457 12.83 52.27C12.83 53.7943 14.0657 55.03 15.59 55.03Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 20.19C62.0243 20.19 63.26 18.9543 63.26 17.43C63.26 15.9057 62.0243 14.67 60.5 14.67C58.9757 14.67 57.74 15.9057 57.74 17.43C57.74 18.9543 58.9757 20.19 60.5 20.19Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.83 31.1701L31.17 18.3301L45.83 33.0001L51.33 25.6701L64.17 36.6701",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.59 57.74C17.11 57.74 18.34 58.97 18.34 60.49V78.83H12.84V60.49C12.84 58.97 14.07 57.74 15.59 57.74Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44 55.03C45.5243 55.03 46.76 53.7943 46.76 52.27C46.76 50.7457 45.5243 49.51 44 49.51C42.4757 49.51 41.24 50.7457 41.24 52.27C41.24 53.7943 42.4757 55.03 44 55.03Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44 57.74C45.52 57.74 46.75 58.97 46.75 60.49V78.83H41.25V60.49C41.25 58.97 42.48 57.74 44 57.74Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.43 55.03C73.9543 55.03 75.19 53.7943 75.19 52.27C75.19 50.7457 73.9543 49.51 72.43 49.51C70.9056 49.51 69.67 50.7457 69.67 52.27C69.67 53.7943 70.9056 55.03 72.43 55.03Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.43 57.74C73.95 57.74 75.18 58.97 75.18 60.49V78.83H69.68V60.49C69.68 58.97 70.91 57.74 72.43 57.74Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3499 60.5C25.9799 65.76 33.6099 65.76 41.2399 60.5",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7499 60.5C54.3799 65.76 62.0099 65.76 69.6399 60.5",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExhibition);
export default __webpack_public_path__ + "static/media/exhibition.893fd4dc119b9781dca295a71dfeee55.svg";
export { ForwardRef as ReactComponent };